<template>
  <main class="layout--plain">
    <NuxtLoadingIndicator color="#bf3bd9"/>
    <slot />
  </main>
</template>
